module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: ['pt-page', 'pt-page-2', 'mod-intro',
      _vm.meanList[1].clicked ? 'pt-page-current' : '',
      _vm.meanList[1].leave ? 'pt-page-moveToTop pt-page-current' : '',
      _vm.meanList[1].enter ? 'pt-page-scaleUp' : ''
    ],
    attrs: {
      "id": "mod-intro"
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod-section-intro content-container"
  }, [_c('h2', [_c('span', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', [_vm._v("Web（3YEARS/ING）")])])]), _c('span', {
    staticClass: "second"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', {
    staticClass: "anim"
  }, [_vm._v("Java（1YEAR）")])])])]), _vm._v(" "), _c('p', {
    staticClass: "infoText anim"
  }, [_vm._v("\n    经历：企业后台管理、定制网站网页、IPTV平板、微信公众号、微信小程序。"), _c('br'), _vm._v("\n    应用及框架：MySQL、Spring、SpringMVC、Hibernate、JQuery、Sea、Cordova、Zepto、Vue。"), _c('br'), _vm._v("\n    接触过：SVN、Java、JavaScript、HTML、CSS、Hexo、Coding、GitHub、阿里云、七牛云\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "infoText_2 anim"
  }, [_vm._v("\n    我喜欢coding，但不专注于当专家级别，我想要的是宽度而不是深度。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper anim"
  }, [_c('a', {
    staticClass: "cta button",
    attrs: {
      "href": "https://www.vmartaw.com/zcc/2017/02/09/2017%E5%B9%B4%E6%AF%8F%E4%B8%80%E4%B8%AA%E4%B8%8D%E6%9B%BE%E8%B5%B7%E8%88%9E%E7%9A%84%E6%97%A5%E5%AD%90%E9%83%BD%E6%98%AF%E5%AF%B9%E7%94%9F%E5%91%BD%E7%9A%84%E8%BE%9C%E8%B4%9F/",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("每一个不曾起舞的日子都是对生命的辜负")])])]), _vm._v(" "), _c('div', {
    staticClass: "award anim"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b13ad2a!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/page/Intro.vue
// module id = 238
// module chunks = 0